import request from "@/plugin/axios";
import axios from "axios";
import util from "@/libs/util";
const token = util.cookies.get("token");

export function page(query) {
  return request({
      url: '/api/case/wyCaseInfo/caseList',
      method: 'post',
      data: query
  })
}

export function addObj(obj) {
  return request({
    url: '/api/case/wyCaseInfo/createCase',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/api/case/wyCaseInfo/' + id,
    method: 'get'
  })
}

export function putObj(id, obj) {
  return request({
    url: '/api/case/wyCaseInfo/' + id,
    method: 'put',
    data: obj
  })
}

export function delObj(id) {
  return request({
    url: '/api/case/wyCaseInfo/' + id,
    method: 'delete'
  })
}

export function transferToMediation(id, obj) {
  return request({
    url: '/api/case/wyCaseInfo/transferToMediation/' + id,
    method: 'put'
  })
}

export function createCaseFiling(obj) {
  return request({
    url: '/api/case/wyCaseInfo/createCaseFiling',
    method: 'put',
    data: obj
  })
}

export function mediationSuccess(obj) {
  return request({
    url: '/api/case/wyCaseInfo/mediationSuccess',
    method: 'put',
    data: obj
  })
}

export function uploadTable(data, token) {
  return axios({
    url: process.env.VUE_APP_API + "/api/case/wyCaseInfo/importCaseExcel",
    method: "post",
    dataType: "json",
    responseType: "application/json",
    data: data,
    headers: {
      authorization: "Bearer " + token,
    },
  });
}